import { FlexContainer, elColGap2, TextSM, Icon, elRowGap4, elColGap4, elMb6 } from '@reapit/elements'
import React from 'react'
import { QuickFilterItem, QuickFiltersCard, QuickFilterStatus } from './quick-filters-card'
import { LoadingSkeleton, Tooltip } from '@reapitform/common-ui'
import { useSearchParams } from 'react-router-dom'
import { useAgreementStatusSummary } from '../../../../api/agreements/agreement-status-summary'
import { css, cx } from '@linaria/core'

export interface QuickFiltersProps {}

export const QuickFilters: React.FC<QuickFiltersProps> = React.memo(() => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { data, loading: isLoading } = useAgreementStatusSummary()
  const activeFilter: QuickFilterStatus | undefined =
    (searchParams.get('filterByStatus') as QuickFilterStatus) ?? undefined
  const handleQuickFilterChanges = (status: QuickFilterStatus | null) => {
    setSearchParams((params) => {
      if (!status) params.delete('filterByStatus')
      else params.set('filterByStatus', status)
      params.set('pageNumber', '1')
      return params
    })
  }

  const quickFilterMenus: QuickFilterItem[] = React.useMemo(
    () => [
      {
        title: 'Signed',
        value: data?.signed ?? '-',
      },
      {
        title: 'Blocked',
        value: data?.blocked ?? '-',
      },
      {
        title: 'Expired',
        value: data?.expired ?? '-',
      },
      {
        title: 'Pending',
        value: data?.pending ?? '-',
      },
      {
        title: 'Draft',
        value: data?.draft ?? '-',
      },
    ],
    [data],
  )

  return (
    <FlexContainer isFlexColumn className={cx(elRowGap4, elMb6)}>
      <FlexContainer isFlexJustifyBetween isFlexAlignCenter>
        <FlexContainer isFlexAlignCenter className={elColGap2}>
          <TextSM hasBoldText>Quick Filters</TextSM>
          <Tooltip tooltipContent="Select a card to apply or remove the filter">
            <Icon
              icon="info"
              fontSize="16px"
              className={css`
                &.el-icon {
                  color: var(--color-grey-300);
                }
              `}
            />
          </Tooltip>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className={elColGap4}>
        {quickFilterMenus.map((quickFilterItem) => {
          if (isLoading) return <LoadingSkeleton key={quickFilterItem.title} width="160px" height="96px" />
          return (
            <QuickFiltersCard
              key={quickFilterItem.title}
              items={quickFilterItem}
              isActive={quickFilterItem.title === activeFilter}
              onClick={handleQuickFilterChanges}
              filterBy="Status"
            />
          )
        })}
      </FlexContainer>
    </FlexContainer>
  )
})
